<template>
  <div>
		<section class="page-distribution-resource">
				<header-page 
				name="distribution"
				:title="$route.meta.title"
				/>
				<div class="px-5 mb-5">
					<app-table
					:columns="columns"
					:check-all="checkAll"
					:selected-value="selectedValue"
					selectable
					class="mt-5"
					:rows="rows"
					:check-row="checkRow"
					:current-page="currentPage"
					:last-page="this.lastPage"
					@on-search-event="onSearch"
					@on-page="changePage"
					@row-is-selected="rowIsSelected"
					@on-selected-all="allIsSelected"
					>
					<template slot="rows" slot-scope="props">
						<td>{{props.row.razonSocial}}</td>
						<td>{{ props.row.codeCompany }}</td>
						<td>{{props.row.ruc}}</td>
						<td>{{props.row.country ? props.row.country.data.name : ''}}</td>
						<td>
							<v-tooltip top>
								<v-btn 
								class="btn-action btn-distribution" 
								@click="openConfirmDialog(props.row)" 
								slot="activator">
									<v-icon color="primary">tune</v-icon>
								</v-btn>
								<span>Personalización a la empresa</span>
							</v-tooltip>
							<app-tooltip-button
								color="primary"
								icon="people_outline"
								text="Usuarios por compañia"
								@click-icon="goToUser(props.row)"
							/>	
						</td>
						</template>
					</app-table>
					<v-dialog v-model="dialog" persistent max-width="500">
						<v-card>
							<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
								<v-card-actions class="justify-center">
								<v-btn
									class="btn-action"
									color="green"
									dark
									@click.native="postDistribution"
									:disabled="loading"
								>
									SI
								</v-btn>
								<v-btn
									class="btn-action"
									color="error"
									dark
									@click.native="close"
								>
									NO
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>
				<v-card-actions class="justify-center mt-5">
					<v-btn
					class="btn-action caption mr-1"
					color="primary"
					@click="returnDistribution"
					>
						Cancelar
					</v-btn>
					<v-btn
						class="btn-action caption mr-1"
						color="green"
						@click="updateDistribution"
					>
						Distribuir
					</v-btn>
				</v-card-actions>
		</section>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

async function updateDistribution() {
	const newArrayDistribution = this.dataSelected.map(item => item.id);
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const body = {
		companiesId: newArrayDistribution,
	};
	const url = `project/${this.codeProject}/distribution/${this.idDistribution}`;
	try {
		await this.$http.patch(url, body, { headers });
		this.showNotification('Se ha distribuido los recursos');
	} catch (error) {
		if (error.status === 405) {
			if (error.data.message === "TEMPLATE_HAVEN'T_ASSOCIATED_DATA") {
				this.showNotification('Plantilla no tiene datos asociados');
			}
		}
	}
}

async function postDistribution() {
	this.loading = true;
	try {
		await this.$http.post(`template/${this.idDistribution}/companies/${this.rowId}`);
		this.showNotification(`Se ha generado una nueva plantilla relacionada a su compañia ${this.nameCompany}`);
		this.close();
		this.listDistribution();
	} catch (error) {
		this.showError();
	} finally {
		this.loading = false;
	}
}

function openConfirmDialog({ id, razonSocial }) {
	this.nameCompany = razonSocial;
	this.rowId = id;
	this.dialogMessage = `¿Desea hacerle una personalización a la empresa '${razonSocial}'?`;
	this.dialog = true;
}

function close() {
	this.dialog = false;
}

function created() {
	this.listDistribution();
}

async function listDistribution() {
	try {
		const params = {
			params: this.params,
		};
		const response = await this.$http.get(`template/${this.idDistribution}/companies`, params);
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
		this.checkAll = this.rows.every(r => r.isSelected);
		this.dataSelected = this.rows.filter(r => r.isSelected);
	} catch (error) {
		this.showError();
	}
}

function returnDistribution() {
	this.goTo('page-template');
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.listDistribution();
}

function onSearch(value) {
	this.params.search = value;
	this.listDistribution();
}

function rowIsSelected(row) {
	this.rows = this.selectIsRow(this.rows, this.selectedValue, row);
	this.checkAll = this.every(this.rows, this.selectedValue);
	this.setDataSelected(row);
}

function setDataSelected(row) {
	if (!row) {
		if (this.checkAll) {
			this.table.rows.forEach((rowData) => {
				const index = this.dataSelected.finIndex(d => d.id === rowData.id);
				if (index < 0) {
					this.dataSelected.push(rowData);
				}
			});
		} else {
			this.table.rows.forEach((rowData) => {
				const index = this.dataSelected.finIndex(d => d.id === rowData.id);
				if (index >= 0) {
					this.dataSelected.splice(index, 1);
				}
			});
		}
	} else {
		const index = this.dataSelected.findIndex(d => d.id === row.id);
		if (index < 0) {
			this.dataSelected.push(row);
		} else {
			this.dataSelected.splice(index, 1);
		}
	}
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.rows = this.selectIsRow(this.rows, this.selectedValue, false, checked);
	this.dataSelected = checked ? this.rows : [];
}

function goToUser({ codeCompany }) {
	this.goTo('page-user', {
		params: { codeProject: this.codeProject, idCompany: codeCompany },
		query: {
			returnTo: 'page-distribution-of-resources',
			returnParams: JSON.stringify({
				codeProject: this.codeProject,
				idDistribution: this.idDistribution,
			}),
		},
	});
}

function data() {
	return {
		dataSelected: [],
		loading: false,
		checkAll: false,
		checkRow: false,
		companiesId: '',
		selectedValue: 'isSelected',
		dialogMessage: '',
		dialog: false,
		codeApp: '',
		currentPage: 1,
		lastPage: 1,
		rows: [],
		columns: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Código Compañía', value: 'code', checked: true, visible: true },
			{ id: 3, name: 'RUC', value: 'ruc', checked: true, visible: true },
			{ id: 4, name: 'Estado', value: 'state', checked: true, visible: true },
			{ id: 5, name: 'Acciones', value: 'action', checked: true, visible: true },
		],
		params: {
			page: 1,
			perPage: 20,
			search: null,
		},
	};
}

export default {
	name: 'page-distribution-of-resources',
	created,
	data,
	components: {
		appTooltipButton,
	},
	methods: {
		updateDistribution,
		postDistribution,
		close,
		goToUser,
		onSearch,
		openConfirmDialog,
		rowIsSelected,
		allIsSelected,
		changePage,
		returnDistribution,
		setDataSelected,
		listDistribution,
	},
	props: {
		idDistribution: [Number, String],
		codeProject: String,
		codeTemplate: [Number, String],
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/template/page-distribution-of-resources.vue